import { HttpClient } from "../../../../services/http/http-client";
import { MODIFICATION_URL } from "../../../../services/common-urls";
import { BOOKING_URL, BOOKINGS_STRING } from "../booking-service";

const CALENDAR_BOOKINGS_NEW_DEALS = 'calendar_bookings_new_deals';
const TEXT = 'text';
const INVOICE_LINES = 'invoicelines';
const BOOKING_CALENDAR_REMOVE_INVOICE_LINES = 'booking_calendar_remove_invoice_line';
export const moneyDetailsService = {
  getMoneyDetails: (calendarDateId = 0) => {
    return HttpClient.get(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: CALENDAR_BOOKINGS_NEW_DEALS,
      calendar_date_id: calendarDateId
    });
  },
  getMoneyDetailsWithInvoices: (calendarDateId = 0, options) => {
    return HttpClient.get(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: CALENDAR_BOOKINGS_NEW_DEALS,
      calendar_date_id: calendarDateId
    }, options);
  },
  updateInvoiceLineText: (invoiceId, value) => {
    return HttpClient.modify(
      undefined,
      invoiceId,
      TEXT,
      value,
      INVOICE_LINES
    );
  },
  removeInvoiceLine: (
    invoiceLineId
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: BOOKING_CALENDAR_REMOVE_INVOICE_LINES,
    invoiceline_id: invoiceLineId
  })
};